import { useState } from 'react';
import { Form } from 'antd';

import CaptchaInput from 'src/components/Inputs/Captcha';
import SelectInput from 'src/components/Inputs/Select';
import SubmitFormButton from 'src/components/Inputs/SubmitForm';
import TextAreaInput from 'src/components/Inputs/TextArea';
import TextFieldInput from 'src/components/Inputs/TextField';
import messageC from 'src/components/Message';
import { fetchApiPublishing } from 'src/utils/fetch-api';

import classes from './index.module.css';
const FormContent = () => {
	const [processing, setProcessing] = useState(false);
	const [form] = Form.useForm();
	const onHandleFinishForm = async (values: any) => {
		try {
			setProcessing(true);
			const resSubmit = await fetchApiPublishing({
				url: '/contact-us',
				options: { method: 'POST' },
				payload: {
					type: 'mitra_korporasi',
					mitra: values.mitra,
					phone: values.phone,
					email: values.email,
					needs: values.needs,
					content: values.content,
					['g-recaptcha-response']: values['google-captcha'],
				},
			});
			setProcessing(false);
			if (resSubmit.status === 200) {
				messageC('Sukses mengirim pesan');
				form.resetFields();
			} else {
				messageC('Gagal mengirim pesan', 'error');
				setProcessing(false);
			}
		} catch (error: any) {
			messageC('Gagal mengirim pesan', 'error');
			setProcessing(false);
		}
	};

	const checkPhoneNumberFormat = (_: any, value: string) => {
		const regexPhoneNumber = /^[+]*[(]?\d{1,4}[)]?[-\s\./0-9]*$/g;
		if (value.match(regexPhoneNumber)) {
			return Promise.resolve();
		} else if (value.length <= 0) {
			return Promise.reject(new Error('Nomor ponsel harus diisi.'));
		}

		return Promise.reject(new Error('Format nomor ponsel tidak sesuai.'));
	};

	return (
		<Form
			className={classes.wrapper}
			autoComplete="off"
			name="contact-us-form"
			onFinish={onHandleFinishForm}
			form={form}
			layout="vertical"
		>
			<TextFieldInput
				name="mitra"
				label="Kami Dari"
				placeholder="Tulis kami dari"
				rules={[
					{
						required: true,
						message: 'Kami dari harus diisi',
					},
				]}
			/>

			<TextFieldInput
				name="phone"
				label="Nomor Ponsel"
				placeholder="Tulis nomor ponsel"
				rules={[
					{
						validator: checkPhoneNumberFormat,
					},
				]}
			/>

			<TextFieldInput
				name="email"
				label="Email"
				placeholder="Tulis email"
				rules={[
					{
						required: true,
						message: 'Email harus diisi',
					},
					{
						type: 'email',
						message: 'Format email tidak sesuai',
					},
				]}
			/>

			<SelectInput
				name="needs"
				label="Tujuan"
				placeholder="Pilih salah satu"
				options={[
					{
						label: 'Kerja Sama Produk',
						value: 'Kerja Sama Produk',
					},
					{
						label: 'Kerja Sama Artikel',
						value: 'Kerja Sama Artikel',
					},
					{
						label: 'Iklan berbayar',
						value: 'Iklan berbayar',
					},
				]}
				rules={[
					{
						required: true,
						message: 'Pilih salah satu dari opsi yang diberikan',
					},
				]}
			/>

			<TextAreaInput
				name="content"
				label="Isi Pesan"
				placeholder="Deskripsikan apa yang kamu ingin tanyakan"
				rules={[
					{
						required: true,
						message: 'Isi pesan harus diisi',
					},
				]}
			/>

			<div className={classes.captcha}>
				<CaptchaInput
					name="google-captcha"
					sitekey={`${process.env.NEXT_PUBLIC_GOOGLE_RECAPTCHA_SITE_KEY}`}
				/>
			</div>

			<SubmitFormButton label="Kirim Pesan" isProcessing={processing} block />
		</Form>
	);
};

export default FormContent;
